
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";

interface AgreementBarProps {
  percentage: number;
}

const AgreementBar = ({ percentage }: AgreementBarProps) => {
  // Determine the appropriate color based on the agreement percentage
  // Restoring brighter colors that match the theme
  const getProgressColor = () => {
    if (percentage >= 75) return "bg-green-500"; // Bright green for high agreement
    if (percentage >= 50) return "bg-green-400"; // Medium green for good agreement
    if (percentage >= 25) return "bg-amber-400"; // Amber for moderate agreement
    return "bg-red-400";                         // Red for low agreement
  };

  return (
    <div className="mb-4">
      <div className="flex justify-between text-sm mb-1">
        <span>Agreement</span>
        <span className="font-medium">{percentage}%</span>
      </div>
      <Progress 
        value={percentage} 
        className="bg-secondary"
        // Apply the color with a custom CSS variable for the progress indicator
        style={{
          "--progress-indicator-color": `var(--${getProgressColor()})`,
        } as React.CSSProperties}
      />
    </div>
  );
};

export default AgreementBar;
